import React from "react";
import { Waves, ArrowRight, Mail, MapPin } from "lucide-react";
import { IMG, RESERVE_URL, navLinks } from "../mock";

export default function Footer() {
  return (
    <footer className="relative">
      {/* Final CTA */}
      <section className="relative py-24 md:py-32 overflow-hidden">
        <div className="orb" style={{ width: 500, height: 500, background: "#06799b", left: "50%", top: -80, transform: "translateX(-50%)", opacity: 0.35 }} />
        <div className="relative mx-auto max-w-4xl px-5 text-center reveal">
          <div className="mx-auto max-w-[280px] mb-8">
            <div className="relative floaty rounded-full overflow-hidden border border-[#e8c874]/25">
              <img src={IMG.meditation} alt="Méditation avec les dauphins" className="w-full" loading="lazy" />
            </div>
          </div>
          <h2 className="font-display text-3xl md:text-5xl font-semibold text-white leading-tight">
            Les Maîtres Dauphins t'attendent.
            <br />
            <span className="gold-gradient-text">Et si c'était maintenant ton grand plongeon ?</span>
          </h2>
          <p className="mt-5 text-white/65 max-w-xl mx-auto">
            Tu peux continuer en mono-conscience. Ou passer dans la pratique du futur :
            cohérence, champ, multi-conscience.
          </p>
          <div className="mt-9">
            <a href={RESERVE_URL} target="_blank" rel="noreferrer"
               className="btn-gold px-8 py-4 inline-flex items-center gap-2 text-lg">
              Je plonge maintenant
              <ArrowRight className="h-5 w-5" />
            </a>
          </div>
        </div>
      </section>

      {/* Footer bar */}
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-5 py-14 grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="grid place-items-center h-9 w-9 rounded-full border border-[#e8c874]/40 text-gold">
                <Waves className="h-4 w-4" />
              </span>
              <span className="font-display text-lg text-white">École des Maîtres Dauphins</span>
            </div>
            <p className="mt-4 text-sm text-white/55 max-w-xs leading-relaxed">
              Le futur de l'accompagnement : multi-conscience, cohérence, champ.
              Présentiel &amp; distance.
            </p>
          </div>

          <div>
            <div className="text-white font-medium">Navigation</div>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-white/55 hover:text-gold transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-white font-medium">Contact</div>
            <ul className="mt-4 space-y-3 text-sm text-white/55">
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 text-gold mt-0.5 shrink-0" />
                Espace Asanoha, 7 Rue de l'Église, 11200 Ornaisons
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-gold shrink-0" />
                gilles@centre-terre-ciel.com
              </li>
            </ul>
          </div>
        </div>
        {/* Legal disclaimer */}
        <div className="border-t border-white/10">
          <div className="mx-auto max-w-5xl px-5 py-8">
            <p className="text-[11px] leading-relaxed text-white/35 text-center">
              Ce site ne fait pas partie du site YouTube™️, Google™️, Facebook™️,
              Google Inc. ou Facebook Inc. De plus, ce site n'est PAS approuvé par
              YouTube™️, Google™️ ou Facebook™️ en aucune façon. FACEBOOK™️ est une
              marque de commerce de FACEBOOK, Inc. GOOGLE™️ et YOUTUBE™️ sont des
              marques de commerce de GOOGLE Inc.
            </p>
          </div>
        </div>
        <div className="border-t border-white/10">
          <div className="mx-auto max-w-7xl px-5 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
            <p className="text-xs text-white/40">
              © 2024-2033 GILLES DELIEUZE — Tous droits réservés
            </p>
            <div className="flex items-center gap-5 text-xs text-white/40">
              <span className="hover:text-white/70 cursor-pointer transition-colors">Confidentialité</span>
              <span className="hover:text-white/70 cursor-pointer transition-colors">CGV</span>
              <span className="hover:text-white/70 cursor-pointer transition-colors">Mentions légales</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
